import { render } from "./GoogleBasicPieChart.vue?vue&type=template&id=245101f8"
import script from "./GoogleBasicPieChart.vue?vue&type=script&lang=js"
export * from "./GoogleBasicPieChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__